import { useContext } from "react";
import { LeadDetailsStore } from "../stores/LeadDetailsStore";
import { LeadDetailsContext } from "../providers/LeadDetailProvider";

export const useLeadDetailsStore = (): LeadDetailsStore => (
  useContext(LeadDetailsContext).leadDetailsStore
);

export default useLeadDetailsStore;
